export enum SingleGraphType{
  LINECHART,
  BARCHART,
  WINDCHART
}
